<div class="surface-card border-round-xl p-3 shadow-1">
    <div class="flex flex-column gap-4">
        <!-- Galeria -->
        <div class="flex flex-column md:flex-row gap-3">
            <!-- Miniaturas (no mobile vira horizontal) -->
            <div class="flex flex-row md:flex-column gap-2 md:gap-3 md:w-4rem w-full md:order-0 order-1 overflow-auto md:overflow-visible">
                <ng-container *ngIf="!isLoadingSkeleton; else loadingSkeleton">
                    <img *ngFor="let image of productImages" [src]="image" [alt]="getProductTitle()"
                        class="thumbnail flex-shrink-0 cursor-pointer border-2 border-transparent border-round transition-colors transition-duration-150"
                        [class.border-primary]="image === mainImage" (click)="changeMainImage(image)">
                </ng-container>

                <ng-template #loadingSkeleton>
                    <p-skeleton width="70px" height="70px" class="border-round flex-shrink-0"></p-skeleton>
                    <p-skeleton width="70px" height="70px" class="border-round flex-shrink-0"></p-skeleton>
                    <p-skeleton width="70px" height="70px" class="border-round flex-shrink-0"></p-skeleton>
                    <p-skeleton width="70px" height="70px" class="border-round flex-shrink-0"></p-skeleton>
                </ng-template>
            </div>

            <!-- Imagem principal -->
            <div class="flex-1 md:order-1 order-0">
                <div class="main-image-container surface-50 border-round-lg">
                    <ng-container *ngIf="!isLoadingSkeleton; else loadingMainImage">
                        <img class="main-image" [src]="mainImage" [alt]="getProductTitle()">
                    </ng-container>

                    <ng-template #loadingMainImage>
                        <div style="width: 100%; height: 320px;">
                            <p-skeleton width="100%" height="100%" class="border-round-lg"></p-skeleton>
                        </div>
                    </ng-template>
                </div>
            </div>
        </div>

        <!-- Título + Preços -->
        <div class="flex flex-column gap-2">
            <ng-container *ngIf="!isLoadingSkeleton && product; else loadingTitleAndPrice">
                <div class="flex align-items-start justify-content-between gap-3">
                    <div class="flex-1 min-w-0">
                        <div class="text-xl font-semibold text-900 line-height-2 overflow-hidden text-overflow-ellipsis">
                            {{ getProductTitle() }}
                        </div>
                    </div>
                    <p-tag *ngIf="selectedChildProduct?.tracked && maxQuantity === 0" severity="danger">
                        sem estoque!
                    </p-tag>
                </div>

                <div class="flex align-items-baseline gap-3 flex-wrap">
                    <span *ngIf="(selectedChildProduct && +selectedChildProduct.compare_at_price > +selectedChildProduct.price) || 
                                (!selectedChildProduct && +product.compare_at_price > +product.price)"
                        class="text-500 font-normal text-lg line-through">
                        {{ selectedChildProduct?.compare_at_price || product.compare_at_price | currency:'BRL':'symbol':'1.2-2' }}
                    </span>
                    <span class="text-900 font-semibold text-3xl">
                        {{ selectedChildProduct?.price || product.price | currency:'BRL':'symbol':'1.2-2' }}
                    </span>
                </div>
            </ng-container>

            <ng-template #loadingTitleAndPrice>
                <p-skeleton width="80%" height="1.8rem" class="mb-2 border-round"></p-skeleton>
                <p-skeleton width="45%" height="2rem" class="border-round"></p-skeleton>
            </ng-template>
        </div>

        <!-- Variantes -->
        <ng-container *ngIf="!isLoadingSkeleton; else loadingAttributes">
            <div *ngFor="let attribute of attributes" class="flex flex-column gap-2">
                <div class="flex align-items-center justify-content-between">
                    <span class="font-semibold text-900">{{ attribute.name }}</span>
                </div>
                <div class="flex flex-wrap gap-2">
                    <div *ngFor="let value of attribute.values"
                        class="px-3 py-2 border-1 border-300 text-900 inline-flex align-items-center justify-content-center border-round cursor-pointer hover:surface-100 transition-duration-150 transition-colors white-space-nowrap"
                        [class.border-blue-500]="selectedAttributes[attribute.name] === value"
                        [class.text-blue-500]="selectedAttributes[attribute.name] === value"
                        (click)="selectAttribute(attribute.name, value)">
                        {{ value }}
                    </div>
                </div>
            </div>
        </ng-container>
        <ng-template #loadingAttributes>
            <p-skeleton width="40%" height="1.2rem" class="mb-2 border-round"></p-skeleton>
            <p-skeleton width="100%" height="2.5rem" class="border-round"></p-skeleton>
        </ng-template>

        <!-- Detalhes -->
        <div class="border-top-1 surface-border pt-3">
            <div class="text-900 font-semibold text-xl mb-2">Detalhes</div>
            <ng-container *ngIf="!isLoadingSkeleton; else loadingDetails">
                <div class="line-height-3 text-600 m-0 s-s-l-productDetails" *ngIf="product"
                    [innerHTML]="product.description"></div>
            </ng-container>
            <ng-template #loadingDetails>
                <p-skeleton width="100%" height="1.2rem" class="mb-2 border-round"></p-skeleton>
                <p-skeleton width="90%" height="1.2rem" class="mb-2 border-round"></p-skeleton>
                <p-skeleton width="80%" height="1.2rem" class="border-round"></p-skeleton>
            </ng-template>
        </div>
    </div>
</div>

<app-dialog-aguarde [visible]="displayAguarde"></app-dialog-aguarde>
